import { render } from "./Offerings.vue?vue&type=template&id=13f0c612"
import script from "./Offerings.vue?vue&type=script&lang=js"
export * from "./Offerings.vue?vue&type=script&lang=js"
script.render = render

export default script